import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import LoginPage from './pages/LoginPage.jsx'
import RecoverPasswordPage from './pages/RecoverPasswordPage.jsx'
import Shell from './components/Shell.jsx'
import DashboardPage from './pages/DashboardPage.jsx'
import PrivateRoute from './auth/PrivateRoute.jsx'
import RequirePermission from './auth/RequirePermission.jsx'
import DeliveryPage from './pages/DeliveryPage.jsx'
import OrdersPage from './pages/OrdersPage.jsx'
import ReportsPage from './pages/ReportsPage.jsx'
import SettingsPage from './pages/SettingsPage.jsx'
import ProductsPage from './pages/ProductsPage.jsx'
import EmployeesPage from './pages/EmployeesPage.jsx'
import PendentesPage from './pages/PendentesPage.jsx'
import AuditLogPage from './pages/AuditLogPage.jsx'
import UsersPage from './pages/UsersPage.jsx'
import EmployeeHistoryPage from './pages/EmployeeHistoryPage.jsx'
import ComprasPage from './pages/ComprasPage.jsx'
import HistoricoComprasPage from './pages/HistoricoComprasPage.jsx'
import SobrePage from './pages/SobrePage.jsx'
import ManualPage from './pages/ManualPage.jsx'
import FinanceiroPage from './pages/FinanceiroPage.jsx'
import ObrasPage from './pages/ObrasPage.jsx'
import CadastroEmpresaPage from './pages/CadastroEmpresaPage.jsx'
// TELA NOTIFICAÇÕES REMOVIDA - import NotificacoesPage from './pages/NotificacoesPage.jsx'
import SuperAdminPage from './pages/SuperAdminPage.jsx'
import { canAccessSettings, canEditCatalog, canMoveStock, canViewReports, canAccessCompras, canViewHistoricoCompras, canViewEstoque, canCreatePedidos } from './utils/permissions.js'
import { autoBackupCheck } from './data/backup.js'
import { useAuth } from './auth/AuthProvider.jsx'

function AutoBackupWatcher() {
  const { session } = useAuth()
  
  useEffect(() => {
    // Verificar backup a cada 5 minutos
    const interval = setInterval(() => {
      autoBackupCheck({ usuario: session })
    }, 5 * 60 * 1000)
    
    // Verificar também ao carregar
    autoBackupCheck({ usuario: session })
    
    return () => clearInterval(interval)
  }, [session])
  
  return null
}

function CompradorRedirect({ children }) {
  const { session } = useAuth()
  const location = useLocation()
  
  if (session?.perfil === 'comprador') {
    const allowedPaths = ['/app/compras', '/app/estoque', '/app/historico-compras', '/app/sobre', '/login']
    const isAllowed = allowedPaths.some(path => location.pathname.startsWith(path))
    if (!isAllowed) return <Navigate to="/app/compras" replace />
  }
  
  return children
}

function DataImportWatcher() {
  const [importStatus, setImportStatus] = useState({ show: false, message: '', type: 'info' })
  
  useEffect(() => {
    const handleImportStart = (e) => {
      setImportStatus({ show: true, message: e.detail.message, type: 'info' })
    }
    
    const handleImportProgress = (e) => {
      setImportStatus({ show: true, message: e.detail.message, type: 'info' })
    }
    
    const handleImportSuccess = (e) => {
      setImportStatus({ show: true, message: e.detail.message, type: 'success' })
      // Esconder após 5 segundos
      setTimeout(() => {
        setImportStatus(prev => ({ ...prev, show: false }))
      }, 5000)
    }
    
    const handleImportWarning = (e) => {
      setImportStatus({ show: true, message: e.detail.message, type: 'warning' })
      setTimeout(() => {
        setImportStatus(prev => ({ ...prev, show: false }))
      }, 3000)
    }
    
    const handleImportError = (e) => {
      setImportStatus({ show: true, message: e.detail.message, type: 'error' })
      setTimeout(() => {
        setImportStatus(prev => ({ ...prev, show: false }))
      }, 5000)
    }
    
    // Adicionar listeners
    window.addEventListener('dataImportStart', handleImportStart)
    window.addEventListener('dataImportProgress', handleImportProgress)
    window.addEventListener('dataImportSuccess', handleImportSuccess)
    window.addEventListener('dataImportWarning', handleImportWarning)
    window.addEventListener('dataImportError', handleImportError)
    
    // Limpar listeners
    return () => {
      window.removeEventListener('dataImportStart', handleImportStart)
      window.removeEventListener('dataImportProgress', handleImportProgress)
      window.removeEventListener('dataImportSuccess', handleImportSuccess)
      window.removeEventListener('dataImportWarning', handleImportWarning)
      window.removeEventListener('dataImportError', handleImportError)
    }
  }, [])
  
  if (!importStatus.show) return null
  
  const bgColor = importStatus.type === 'success' ? 'bg-emerald-600' :
                  importStatus.type === 'error' ? 'bg-red-600' :
                  importStatus.type === 'warning' ? 'bg-amber-600' :
                  'bg-blue-600'
  
  return (
    <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 ${bgColor} text-white px-4 py-2 rounded-lg shadow-lg text-sm`}>
      {importStatus.message}
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/recuperar-senha" element={<RecoverPasswordPage />} />
      <Route
        path="/app"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <AutoBackupWatcher />
                <DataImportWatcher />
                <DashboardPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/entrega"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <DeliveryPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/pedidos"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <OrdersPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/estoque"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <ProductsPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/funcionarios"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <EmployeesPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/pendentes"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <PendentesPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/relatorios"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <ReportsPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/financeiro"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <FinanceiroPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/obras"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <ObrasPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/configuracoes"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <SettingsPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/usuarios"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <UsersPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/funcionario-historico/:id"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <EmployeeHistoryPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/compras"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <ComprasPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/historico-compras"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <HistoricoComprasPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/auditoria"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <AuditLogPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/sobre"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <SobrePage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      <Route
        path="/app/manual"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <ManualPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      />
      {/* TELA NOTIFICAÇÕES REMOVIDA
      <Route
        path="/app/notificacoes"
        element={
          <PrivateRoute>
            <CompradorRedirect>
              <Shell>
                <NotificacoesPage />
              </Shell>
            </CompradorRedirect>
          </PrivateRoute>
        }
      /> */}
      <Route path="/cadastro" element={<CadastroEmpresaPage />} />
      <Route
        path="/super-admin"
        element={
          <PrivateRoute>
            <SuperAdminPage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
